// extracted by mini-css-extract-plugin
export default {"editor":"LUBzymeHJuqd9WWRS26W"};